export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_00.99d07ad3.jpg";